import { Header, Modal } from '@procurify/ui'
import { useSelector } from 'react-redux'

import { makeSelectFeatureSwitches } from '@webapp/core/stores/global'
import { useProcurifyIntl } from '@webapp/hooks'
import { BudgetCategoryImporter } from './BudgetCategoryImporter'
import messages from './messages'

export interface BudgetCategoryImporterModalProps {
  open?: boolean
  onDismiss?(): void
}

export const BudgetCategoryImporterModal = ({
  open = false,
  onDismiss = () => undefined,
}: BudgetCategoryImporterModalProps) => {
  const intl = useProcurifyIntl()
  const { enable_flexible_spend_tracking: isFlexibleSpendTrackingEnabled } =
    useSelector(makeSelectFeatureSwitches())

  return (
    <Modal
      maxWidth='md'
      open={open}
      onClose={onDismiss}
      aria-labelledby='budget-category-import-modal-title'
    >
      <Modal.Card>
        <Modal.Header onClose={onDismiss}>
          <Header as='h5' id='budget-category-import-modal-title'>
            {intl.formatMessage(
              isFlexibleSpendTrackingEnabled
                ? messages.budgetsImporterModalTitle
                : messages.budgetCategoryImporterModalTitle
            )}
          </Header>
        </Modal.Header>
        <Modal.Content>
          <BudgetCategoryImporter handleModalClose={onDismiss} />
        </Modal.Content>
      </Modal.Card>
    </Modal>
  )
}
